import React from 'react';

const variants = {
  primary: 'bg-primary-600 text-white hover:bg-primary-700',
  secondary: 'bg-secondary-500 text-white hover:bg-secondary-600',
  success: 'bg-success-500 text-white hover:bg-success-600',
  danger: 'bg-danger-500 text-white hover:bg-danger-600',
  outline: 'border border-gray-300 text-gray-700 hover:bg-gray-50',
};

const sizes = {
  sm: 'px-3 py-2 text-sm min-h-[44px] min-w-[44px]',
  md: 'px-4 py-2.5 min-h-[44px]',
  lg: 'px-6 py-3 text-lg min-h-[48px]',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  type = 'button',
  className = '',
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`
        font-medium rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed
        focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        ${variants[variant]} ${sizes[size]} ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
}
